'use strict';
import * as $j_app$002eutils$002e$002dTauri$0024$002dOn$002dClose$002dBehaviour$0024$0024anon$00242 from "./app.utils.-Tauri$-On-Close-Behaviour$$anon$2.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $s_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray__Lapp_utils_Tauri$OnCloseBehaviour() {
  $m_Lapp_utils_Tauri$OnCloseBehaviour$();
  return $t_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray;
}
export { $s_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray__Lapp_utils_Tauri$OnCloseBehaviour as $s_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray__Lapp_utils_Tauri$OnCloseBehaviour };
function $s_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize__Lapp_utils_Tauri$OnCloseBehaviour() {
  $m_Lapp_utils_Tauri$OnCloseBehaviour$();
  return $t_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize;
}
export { $s_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize__Lapp_utils_Tauri$OnCloseBehaviour as $s_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize__Lapp_utils_Tauri$OnCloseBehaviour };
/** @constructor */
function $c_Lapp_utils_Tauri$OnCloseBehaviour$() {
  $n_Lapp_utils_Tauri$OnCloseBehaviour$ = this;
  $t_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray = new $j_app$002eutils$002e$002dTauri$0024$002dOn$002dClose$002dBehaviour$0024$0024anon$00242.$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2("HideToSystemTray", 0);
  $t_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize = new $j_app$002eutils$002e$002dTauri$0024$002dOn$002dClose$002dBehaviour$0024$0024anon$00242.$c_Lapp_utils_Tauri$OnCloseBehaviour$$anon$2("Minimize", 1);
  $s_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray__Lapp_utils_Tauri$OnCloseBehaviour();
  $s_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize__Lapp_utils_Tauri$OnCloseBehaviour();
}
export { $c_Lapp_utils_Tauri$OnCloseBehaviour$ as $c_Lapp_utils_Tauri$OnCloseBehaviour$ };
$c_Lapp_utils_Tauri$OnCloseBehaviour$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_utils_Tauri$OnCloseBehaviour$.prototype.constructor = $c_Lapp_utils_Tauri$OnCloseBehaviour$;
/** @constructor */
function $h_Lapp_utils_Tauri$OnCloseBehaviour$() {
}
export { $h_Lapp_utils_Tauri$OnCloseBehaviour$ as $h_Lapp_utils_Tauri$OnCloseBehaviour$ };
$h_Lapp_utils_Tauri$OnCloseBehaviour$.prototype = $c_Lapp_utils_Tauri$OnCloseBehaviour$.prototype;
$c_Lapp_utils_Tauri$OnCloseBehaviour$.prototype.ordinal__O__I = (function(x) {
  return x.Lapp_utils_Tauri$OnCloseBehaviour$$anon$2__f__$ordinal$2;
});
var $d_Lapp_utils_Tauri$OnCloseBehaviour$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_utils_Tauri$OnCloseBehaviour$, "app.utils.Tauri$OnCloseBehaviour$", ({
  Lapp_utils_Tauri$OnCloseBehaviour$: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Sum: 1
}));
export { $d_Lapp_utils_Tauri$OnCloseBehaviour$ as $d_Lapp_utils_Tauri$OnCloseBehaviour$ };
var $n_Lapp_utils_Tauri$OnCloseBehaviour$;
function $m_Lapp_utils_Tauri$OnCloseBehaviour$() {
  if ((!$n_Lapp_utils_Tauri$OnCloseBehaviour$)) {
    $n_Lapp_utils_Tauri$OnCloseBehaviour$ = new $c_Lapp_utils_Tauri$OnCloseBehaviour$();
  }
  return $n_Lapp_utils_Tauri$OnCloseBehaviour$;
}
export { $m_Lapp_utils_Tauri$OnCloseBehaviour$ as $m_Lapp_utils_Tauri$OnCloseBehaviour$ };
var $t_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray = null;
function $u_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray(x) {
  $t_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray = x;
}
export { $t_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray as $t_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray, $u_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray as $u_Lapp_utils_Tauri$OnCloseBehaviour$__HideToSystemTray };
var $t_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize = null;
function $u_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize(x) {
  $t_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize = x;
}
export { $t_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize as $t_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize, $u_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize as $u_Lapp_utils_Tauri$OnCloseBehaviour$__Minimize };
//# sourceMappingURL=app.utils.-Tauri$-On-Close-Behaviour$.js.map
